//@ts-nocheck
import React, { useEffect, useRef, useState, Fragment } from "react"
import { v4 as uuidv4 } from 'uuid';
import Datepicker from "react-tailwindcss-datepicker";
import { format } from 'date-fns';
import { useLocation, useNavigate, useParams } from 'react-router-dom';
import { useSearch } from "../../../context/SearchContext";
import { useSidebar } from "../../../context/SidebarContext";
import { fetchJobPipelineDetailsData } from "../../../features/pipeline/pipelineSlice";
import { useAppDispatch, useAppSelector } from "../../../app/hooks";
import { CrossIcon, SortAscendingIcon, SortDecendingIcon } from "../../../components/icons/Icons";
import { DialogBackdrop, DialogPanel, DialogTitle } from '@headlessui/react'
import { Dialog, Listbox, Transition } from '@headlessui/react';
import { toast } from "sonner";
import { X } from "lucide-react";
import { ListboxButton, ListboxOption, ListboxOptions } from '@headlessui/react'
import { _baseRequestFormData, COMMON } from "../../../utils/baseApi";
import BookmarkListing from "./BookmarkListing";

function classNames(...classes: any) {
  return classes.filter(Boolean).join(' ')
}
// Auto-resizing textarea component
const AutoResizeTextarea = ({ value, onChange, placeholder }) => {
  const textareaRef = useRef(null);

  useEffect(() => {
    if (textareaRef.current) {
      // Set initial height to 40px
      textareaRef.current.style.height = "45px";
      // Reset height to auto to get the correct scrollHeight
      textareaRef.current.style.height = "auto";
      // Set the height based on scrollHeight with a minimum of 40px
      textareaRef.current.style.height = `${Math.max(45, textareaRef.current.scrollHeight)}px`;
    }
  }, [value]);

  return (
    <textarea
      ref={textareaRef}
      className="resize-none outline-none bg-transparent focus:border-light-gray-200 focus:outline-none focus:!shadow-none focus:ring-transparent !ring-0 text-[14px] text-dark-black-100 w-full m-0 placeholder:text-[#9e9ea0] border-l border-r 
      border-t-0 border-b
       border-solid border-light-gray-200 rounded-bl-md rounded-br-md p-2"
      placeholder={placeholder}
      value={value}
      onChange={onChange}
      rows={1}
    />
  );
};

export default function BookmarkHeader() {
  const [activeButton, setActiveButton] = useState('one');
  const [sectionHeight, setSectionHeight] = useState(0);
  const [isMainMenuOpen, setIsMainMenuOpen] = useState(false);
  const [boardsMenuOpen, setBoardsMenuOpen] = useState(false);
  const [createdMenuOpen, setCreatedMenuOpen] = useState(false);
  const storedFilters = localStorage.getItem('activeFiltersBookmark');
  const initialFilters = storedFilters ? JSON.parse(storedFilters) : {
    Stages: [],
    'Created at': [],
    'Updated By': [],
    'Sort': [],
    'AI rating': [],
    'User rating': [],
    search: '',
    //pagination 
    pagination: {
      pageIndex: 0,
      pageSize: 25
    }
  };
  const [activeFilters, setActiveFilters] = useState({
    ...initialFilters,
    // search: searchTerm, 
  });
  const [searchQuery, setSearchQuery] = useState("");
  const [createdSearchQuery, setCreatedSearchQuery] = useState("");
  const selectedValuesRef = useRef<HTMLDivElement>(null);
  const [localItemBoards, setLocalItemBoards] = useState([])
  const [localItemStatus, setLocalItemStatus] = useState([])
  const [activeIndex1, setActiveIndex1] = useState(-1);
  const [boardsSearchQuery, setBoardsSearchQuery] = useState("");
  const [selectedTags, setSelectedTags] = useState(() => {
    const storedFilters = localStorage.getItem('activeFiltersBookmark');
    const initialFilters = storedFilters ? JSON.parse(storedFilters) : {
      Stages: [], 'Created at': [], 'Updated By': [], 'AI rating': [], 'User rating': [],
      search: ''
    };
    return initialFilters.member || [];
  });

  const [updatedMenuOpen, setUpdatedMenuOpen] = useState(false);
  const [assignedItemId, setAssignedItemId] = useState<string | null>(null);
  const { searchTerm, clearAll } = useSearch();
  const location = useLocation();
  const [assignedStatusDraftId, setAssignedStatusDraftId] = useState<string | null>(null);
  const [assignedStatusPendingId, setAssignedStatusPendingId] = useState<string | null>(null);
  const [assignedStatusCompletedId, setAssignedStatusCompletedId] = useState<string | null>(null);
  const [activeStatus, setActiveStatus] = useState('all');
  const { verticleSidebar, setVerticleSidebar } = useSidebar();
  const isChatOpen = useAppSelector((state: any) => state.ui?.isChatbotOpen);
  const [showKanbanRoute, setShowKanbanRoute] = useState(false)
  const [showReports, setShowReports] = useState(false)
  const { jobId } = useParams<{ jobId: string }>();
  const { baseId } = useParams<{ baseId: string }>();
  const navigate = useNavigate();
  const [sortMenuOpen, setSortMenuOpen] = useState(false);
  const sortMenuRef = useRef(null);
  const [sortSearchQuery, setSortSearchQuery] = useState('');
  const [uploadModal, setUploadModal] = useState(false);
  const [isDragging, setIsDragging] = useState(false);
  const [selectedFiles, setSelectedFiles] = useState<File[]>([]);
  const [pipelineStageData, setPipelineStageData] = useState([])
  const optionsWithAllStagesHeader = [...pipelineStageData];
  const [selectedStage, setSelectedStage] = useState(pipelineStageData?.[0] || null);
  const [isLoading, setIsLoading] = useState(false);

  // ai rating 
  const [AiRatingMenuOpen, setAiRatingMenuOpen] = useState(false);
  const aiRatingMenuRef = useRef(null);
  const [aiRatingSearchQuery, setAiRatingSearchQuery] = useState('');

  // user rating
  const [userRatingMenuOpen, setUserRatingMenuOpen] = useState(false);
  const userRatingMenuRef = useRef(null);
  const [userRatingSearchQuery, setUserRatingSearchQuery] = useState('')

  const dispatch = useAppDispatch();
  useEffect(() => {
    if (searchTerm !== undefined) {
      setActiveFilters(prevFilters => ({ ...prevFilters, search: searchTerm }));
    }
  }, [searchTerm]);





  useEffect(() => {
    setActiveFilters({
      ...initialFilters,
      search: '',
    });
  }, [location.pathname]);


  useEffect(() => {
    // Synchronize activeStatus with the current URL
    const path = location.pathname;
    if (path.includes('application')) {
      setActiveStatus('Application');
      setShowKanbanRoute(false);
    } else if (path.includes('pipeline')) {
      setActiveStatus('Pipeline');
      setShowKanbanRoute(true);
    } else if (path.includes('reports')) {
      setActiveStatus('Reports');
      setShowKanbanRoute(false);
    }
  }, [location.pathname]);



  const handleStatusDraft = () => {
    setActiveStatus('Application');
    setShowKanbanRoute(false);
    setShowReports(false);
    navigate(`/${baseId}/job/${jobId}/application`);
  };

  const handleStatusPending = async () => {
    setActiveStatus('Pipeline');
    setShowKanbanRoute(true);
    setShowReports(false);
    navigate(`/${baseId}/job/${jobId}/pipeline`);
    if (jobId && baseId) {
      try {
        const res = await dispatch(fetchJobPipelineDetailsData({ baseId: Number(baseId), JobId: jobId })).unwrap();
        localStorage.setItem('jobPipelineStageData', JSON.stringify(res?.data));
      } catch (error) {
        console.error("Error fetching document:", error);
      }
    }
  };

  const handleStatusCompleted = () => {
    setActiveStatus('Reports');
    setShowKanbanRoute(false);
    setShowReports(true);
    navigate(`/${baseId}/job/${jobId}/reports`);
  };

  // stage
  useEffect(() => {
    if (baseId) {
      const fetchJob = async () => {
        const storedBoardsItems = localStorage.getItem("jobPipelineStageData");
        if (storedBoardsItems) {
          const parsedItems = JSON.parse(storedBoardsItems);
          if (parsedItems && parsedItems) {
            setLocalItemBoards(parsedItems?.stages);
            setPipelineStageData(parsedItems?.stages)
          }
        } else {
          try {
            const res = await dispatch(fetchJobPipelineDetailsData({ baseId: Number(baseId), JobId: jobId })).unwrap();
            if (res && res.data) {
              setLocalItemBoards(res?.data?.stages);
              setPipelineStageData(res?.data?.stages)
              // }
            }
          } catch (error) {
            console.error("Error fetching base member details:", error);
          }
        }
      };
      fetchJob();
    }
  }, [baseId, dispatch]);





  const [editingFilter, setEditingFilter] = useState(null);

  const toggleFilter = (category, newFilter) => {
    setActiveFilters((prevFilters) => ({
      ...prevFilters,
      [category]: [newFilter]
    }));
  };

  // const toggleFilter = (category, newFilter) => {
  //   setActiveFilters((prevFilters) => {
  //     const categoryFilters = prevFilters[category] || [];
  //     const existingFilterIndex = categoryFilters.findIndex(
  //       (filter) => filter.id === newFilter.id
  //     );

  //     let updatedCategoryFilters;
  //     if (existingFilterIndex !== -1) {
  //       updatedCategoryFilters = categoryFilters.map((filter, index) =>
  //         index === existingFilterIndex ? newFilter : filter
  //       );
  //     } else {
  //       updatedCategoryFilters = [...categoryFilters, newFilter];
  //     }
  //     return {
  //       ...prevFilters,
  //       [category]: updatedCategoryFilters
  //     };
  //   });
  // };



  const itemsRef1 = useRef([]);
  useEffect(() => {
    const handleKeyDown = (event) => {
      if (event.key === "ArrowUp") {
        setActiveIndex1((prevIndex) => {
          const newIndex = Math.max(prevIndex - 1, 0);
          scrollItemIntoView(newIndex);
          return newIndex;
        });
      } else if (event.key === "ArrowDown") {
        setActiveIndex1((prevIndex) => {
          const newIndex = Math.min(prevIndex + 1, localItemStatus.length - 1);
          const newIndex1 = Math.min(prevIndex + 1, localItemBoards.length - 1);
          scrollItemIntoView(newIndex);
          scrollItemIntoView(newIndex1);
          return Math.max(newIndex, newIndex1);
        });
      } else if (event.key === "Enter") {
        if (activeIndex1 >= 0) {
          let newFilter = null;
          if (boardsMenuOpen && activeIndex1 < localItemBoards.length) {
            const selectedItem = localItemBoards[activeIndex1];
            newFilter = {
              id: selectedItem.id,
              label: "Stages",
              value: selectedItem.name,
              icon: <BadgeBoards borderColor={selectedItem.color} />
            };
            setBoardsMenuOpen(false);
            setBoardsSearchQuery("");
          }
          // sorting

          if (sortMenuOpen && activeIndex1 < localItemStatus.length) {
            const selectedItem = localItemStatus[activeIndex1];
            newFilter = {
              id: selectedItem.id,
              label: "Sort",
              value: selectedItem.name,
              icon: <BadgeStatus borderColor={selectedItem.color} />
            };
            setSortMenuOpen(false);
            setSortSearchQuery("");
          }

          // ai rating 
          if (AiRatingMenuOpen && activeIndex1 < localItemStatus.length) {
            const selectedItem = localItemStatus[activeIndex1];
            const ratingValue = selectedItem.id;
            const styles = getRatingBadgeStyles(ratingValue);

            newFilter = {
              id: uuidv4(),
              label: "AI rating",
              value: selectedItem.name,
              icon: <span className={`inline-flex items-center rounded-md px-2 py-1 text-xs font-medium ${styles.bg} ${styles.text} ${styles.ring} ring-1 ring-inset`}>{ratingValue}</span>
            };

            setAiRatingMenuOpen(false);
            setAiRatingSearchQuery("");
          }

          // user rating 
          if (userRatingMenuOpen && activeIndex1 < localItemStatus.length) {
            const selectedItem = localItemStatus[activeIndex1];
            const ratingValue = selectedItem.id;
            const styles = getRatingBadgeStyles(ratingValue);

            newFilter = {
              id: uuidv4(),
              label: "User rating",
              value: selectedItem.name,
              icon: <span className={`inline-flex items-center rounded-md px-2 py-1 text-xs font-medium ${styles.bg} ${styles.text} ${styles.ring} ring-1 ring-inset`}>{ratingValue}</span>
            };

            setUserRatingMenuOpen(false);
            setUserRatingSearchQuery("");
          }


          if (newFilter) {
            setActiveFilters((prevFilters) => ({
              ...prevFilters,
              [newFilter.label]: [...(prevFilters[newFilter.label] || []), newFilter]
            }));
          }
        }
      }
    };

    const scrollItemIntoView = (index) => {
      const item = itemsRef1.current[index];
      if (item) {
        item.scrollIntoView({ behavior: "smooth", block: "nearest" });
      }
    };

    window.addEventListener("keydown", handleKeyDown);

    return () => {
      window.removeEventListener("keydown", handleKeyDown);
    };
  }, [localItemStatus, localItemBoards, activeFilters, setActiveFilters,
    setBoardsMenuOpen,
    setBoardsSearchQuery, boardsMenuOpen, sortMenuOpen, setSortMenuOpen,
    AiRatingMenuOpen, setAiRatingMenuOpen, setSortSearchQuery, sortSearchQuery,
    setAiRatingSearchQuery, aiRatingSearchQuery, aiRatingMenuRef, sortMenuRef, activeIndex1,
    userRatingMenuOpen, setUserRatingMenuOpen, userRatingSearchQuery, setUserRatingSearchQuery, userRatingMenuRef


  ]);


  const transformColorClass = (bgClass) => {
    return bgClass.replace('bg-', '');
  };

  // Badge Component
  const BadgeTags = ({ borderColor }) => (
    <span className={`flex h-[8px] w-[8px] shrink-0 items-center justify-center rounded-full text-[0.625rem] font-medium text-white border-2 border-solid border-${borderColor}`} />
  );

  const BadgeBoards = ({ borderColor }) => (
    <span className={`flex h-[8px] w-[8px] shrink-0 items-center justify-center rounded-[2px] text-[0.625rem] font-medium text-white bg-[${borderColor}]`} />
  );

  const BadgeStatus = ({ borderColor }) => (
    <span className={`flex h-[8px] w-[8px] shrink-0 items-center justify-center rounded-full text-[0.625rem] font-medium text-white bg-[${borderColor}]`} />
  );

  const BadgeAssign = ({ borderColor }) => (
    <span className={`flex h-[8px] w-[8px] shrink-0 items-center justify-center rounded-full text-[0.625rem] font-medium text-white ${borderColor}`} />
  );


  const BadgesInternal = ({ borderColor, profilePic }) => (
    <div className="w-5 h-5 rounded-full bg-gray-200 flex items-center justify-center text-[10px] overflow-hidden">
      {profilePic ? (
        <img
          src={
            profilePic
              ? `${process.env.REACT_APP_API_BASE_URL}/${profilePic}`
              : ''
          }
          alt="Profile"
          className="w-full h-full object-cover rounded-full"
        />
      ) : (
        <span className="text-[7px] font-medium text-gray-700">
          {borderColor ? borderColor.charAt(0) : ''}
        </span>
      )}
    </div>
  );


  const hasActiveFilters = Object.values(activeFilters).some(filters => filters.length > 0);
  // const hasActiveFilters = useMemo(() => {
  //   return Object.values(activeFilters).some(filter =>
  //     Array.isArray(filter) ? filter.length > 0 : Boolean(filter)
  //   ) || activeFilters.search;
  // }, [activeFilters]);

  // Add sort options
  const sortOptions = [
    {
      id: uuidv4(),
      label: 'Created first',
      value: 'created_asc',
      icon: <SortAscendingIcon />,
      onClick: () => {
        toggleFilter('Sort', {
          id: uuidv4(),
          value: 'Created first',
          icon: 'sort-icon'
        });
        setSortMenuOpen(false);
        clearPaginationFromState();
      }
    },
    {
      id: uuidv4(),
      label: 'Created last',
      value: 'created_desc',
      icon: <SortDecendingIcon />,
      onClick: () => {
        toggleFilter('Sort', {
          id: uuidv4(),
          value: 'Created last',
          icon: 'sort-icon'
        });
        setSortMenuOpen(false);
        clearPaginationFromState();
      }
    },
    {
      id: uuidv4(),
      label: 'Updated first',
      value: 'updated_asc',
      icon: <SortAscendingIcon />,
      onClick: () => {
        toggleFilter('Sort', {
          id: uuidv4(),
          value: 'Updated first',
          icon: 'sort-icon'
        });
        setSortMenuOpen(false);
        clearPaginationFromState();
      }
    },
    {
      id: uuidv4(),
      label: 'Updated last',
      value: 'updated_desc',
      icon: <SortDecendingIcon />,
      onClick: () => {
        toggleFilter('Sort', {
          id: uuidv4(),
          value: 'Updated last',
          icon: 'sort-icon'
        });
        setSortMenuOpen(false);
        clearPaginationFromState();
      }
    },
    // ai rating accending
    {
      id: uuidv4(),
      label: 'AI rating accending',
      value: 'ai_rating_asc',
      icon: <SortAscendingIcon />,
      onClick: () => {
        toggleFilter('Sort', {
          id: uuidv4(),
          value: 'AI rating accending',
          icon: 'sort-icon'
        });
        setSortMenuOpen(false);
        clearPaginationFromState();
      }
    },
    // ai rating decending
    {
      id: uuidv4(),
      label: 'AI rating decending',
      value: 'ai_rating_desc',
      icon: <SortDecendingIcon />,
      onClick: () => {
        toggleFilter('Sort', {
          id: uuidv4(),
          value: 'AI rating decending',
          icon: 'sort-icon'
        });
        setSortMenuOpen(false);
        clearPaginationFromState();
      }
    },
    // user rating accending
    {
      id: uuidv4(),
      label: 'User rating accending',
      value: 'user_rating_asc',
      icon: <SortAscendingIcon />,
      onClick: () => {
        toggleFilter('Sort', {
          id: uuidv4(),
          value: 'User rating accending',
          icon: 'sort-icon'
        });
        setSortMenuOpen(false);
        clearPaginationFromState();
      }
    },
    // user rating decending
    {
      id: uuidv4(),
      label: 'User rating decending',
      value: 'user_rating_desc',
      icon: <SortDecendingIcon />,
      onClick: () => {
        toggleFilter('Sort', {
          id: uuidv4(),
          value: 'User rating decending',
          icon: 'sort-icon'
        });
        setSortMenuOpen(false);
        clearPaginationFromState();
      }
    }


  ];

  const mainItems = [
    {
      id: uuidv4(),
      label: 'Stages',
      icon: <span className="text-[#1d2025] w-[8px] h-[8px] rounded-[2px] border-2 border-solid border-[#7d7f83] block"></span>,
      menuOpen: boardsMenuOpen,
      setMenuOpen: setBoardsMenuOpen,
    },
    {
      id: uuidv4(),
      label: 'Sort',
      icon: <svg stroke="currentColor" fill="none" strokeWidth="2" viewBox="0 0 24 24" strokeLinecap="round" stroke-linejoin="round" focusable="false" aria-hidden="true"
        height="0.9em" width="0.9em" xmlns="XXXXXXXXXXXXXXXXXXXXXXXXXX">
        <path d="M4 21v-7"></path>
        <path d="M4 10V3"></path>
        <path d="M12 21v-9"></path>
        <path d="M12 8V3"></path>
        <path d="M20 21v-5"></path>
        <path d="M20 12V3"></path>
        <path d="M1 14h6"></path>
        <path d="M9 8h6"></path>
        <path d="M17 16h6"></path>
      </svg>,
      menuOpen: sortMenuOpen,
      setMenuOpen: setSortMenuOpen,
    },
    {
      id: uuidv4(),
      label: 'AI rating',
      icon: <svg
        xmlns="http://www.w3.org/2000/svg"
        fill="none"
        viewBox="0 0 24 24"
        strokeWidth="1.5"
        stroke="currentColor"
        aria-hidden="true"
        data-slot="icon"
        className="w-[0.9rem] h-[0.9rem]"
      >
        <path
          strokeLinecap="round"
          strokeLinejoin="round"
          d="M9.813 15.904 9 18.75l-.813-2.846a4.5 4.5 0 0 0-3.09-3.09L2.25 12l2.846-.813a4.5 4.5 0 0 0 3.09-3.09L9 5.25l.813 2.846a4.5 4.5 0 0 0 3.09 3.09L15.75 12l-2.846.813a4.5 4.5 0 0 0-3.09 3.09ZM18.259 8.715 18 9.75l-.259-1.035a3.375 3.375 0 0 0-2.455-2.456L14.25 6l1.036-.259a3.375 3.375 0 0 0 2.455-2.456L18 2.25l.259 1.035a3.375 3.375 0 0 0 2.456 2.456L21.75 6l-1.035.259a3.375 3.375 0 0 0-2.456 2.456ZM16.894 20.567 16.5 21.75l-.394-1.183a2.25 2.25 0 0 0-1.423-1.423L13.5 18.75l1.183-.394a2.25 2.25 0 0 0 1.423-1.423l.394-1.183.394 1.183a2.25 2.25 0 0 0 1.423 1.423l1.183.394-1.183.394a2.25 2.25 0 0 0-1.423 1.423Z"
        />
      </svg>
      ,
      menuOpen: AiRatingMenuOpen,
      setMenuOpen: setAiRatingMenuOpen,
    },
    {
      id: uuidv4(),
      label: 'User rating',
      icon: <svg
        xmlns="http://www.w3.org/2000/svg"
        width={18}
        height={18}
        viewBox="0 0 24 24"
        fill="none"
        stroke="currentColor"
        strokeWidth={2}
        strokeLinecap="round"
        strokeLinejoin="round"
        className="icon icon-tabler icons-tabler-outline icon-tabler-users w-[0.9rem] h-[0.9rem]"
      >
        <path stroke="none" d="M0 0h24v24H0z" fill="none" />
        <path d="M9 7m-4 0a4 4 0 1 0 8 0a4 4 0 1 0 -8 0" />
        <path d="M3 21v-2a4 4 0 0 1 4 -4h4a4 4 0 0 1 4 4v2" />
        <path d="M16 3.13a4 4 0 0 1 0 7.75" />
        <path d="M21 21v-2a4 4 0 0 0 -3 -3.85" />
      </svg>
      ,
      menuOpen: userRatingMenuOpen,
      setMenuOpen: setUserRatingMenuOpen,
    },
    {
      id: uuidv4(),
      label: 'Created at',
      icon: <svg stroke="currentColor" fill="none" strokeWidth="2" viewBox="0 0 24 24" strokeLinecap="round" stroke-linejoin="round" focusable="false" aria-hidden="true"
        height="0.9em" width="0.9em" xmlns="http://www.w3.org/2000/svg">
        <rect x="3" y="4" width="18" height="18" rx="2" ry="2"></rect>
        <line x1="16" y1="2" x2="16" y2="6"></line>
        <line x1="8" y1="2" x2="8" y2="6"></line>
        <line x1="3" y1="10" x2="21" y2="10"></line>
      </svg>,
      menuOpen: createdMenuOpen,
      setMenuOpen: setCreatedMenuOpen,
    },
    {
      id: uuidv4(),
      label: 'Updated at',
      icon: <svg stroke="currentColor" fill="none" strokeWidth="2" viewBox="0 0 24 24" strokeLinecap="round" stroke-linejoin="round" focusable="false" aria-hidden="true"
        height="0.9em" width="0.9em" xmlns="XXXXXXXXXXXXXXXXXXXXXXXXXX">
        <rect x="3" y="4" width="18" height="18" rx="2" ry="2"></rect>
        <line x1="16" y1="2" x2="16" y2="6"></line>
        <line x1="8" y1="2" x2="8" y2="6"></line>
        <line x1="3" y1="10" x2="21" y2="10"></line>
      </svg>,
      menuOpen: updatedMenuOpen,
      setMenuOpen: setUpdatedMenuOpen,
    },
  ];


  // const getFilterIcon = (label) => {
  //   const matchingItems = mainItems.filter(item => item.label === label);
  //   return matchingItems.map(item => item.icon);
  // };

  // boards
  const boardsItems = localItemBoards?.map((item, index) => ({
    id: item.id,
    label: item.stage_name,
    icon: <BadgeBoards borderColor={item.stage_colour} />,
    onClick: () => {
      toggleFilter('Stages', {
        id: item.id,
        value: item.stage_name,
        icon: <BadgeBoards borderColor={item.stage_colour} />
      });
      setBoardsMenuOpen(false);
      setBoardsSearchQuery("");
      setActiveIndex1(index);
    },
    className: activeIndex1 === index ? 'bg-[#f1f1f2]' : '',
  }));


  // Function to get badge styles based on rating value
  const getRatingBadgeStyles = (rating) => {
    if (!rating) return {
      bg: "bg-gray-50",
      text: "text-gray-700",
      ring: "ring-gray-700/10"
    };

    const ratingValue = parseFloat(rating);

    if (ratingValue === 5) {
      // Strong Yes: Green
      return {
        bg: "bg-green-50",
        text: "text-green-700",
        ring: "ring-green-700/10"
      };
    } else if (ratingValue === 4) {
      // Yes: Light Green
      return {
        bg: "bg-emerald-50",
        text: "text-emerald-700",
        ring: "ring-emerald-700/10"
      };
    } else if (ratingValue === 3) {
      // Neutral: Blue
      return {
        bg: "bg-blue-50",
        text: "text-blue-700",
        ring: "ring-blue-700/10"
      };
    } else if (ratingValue === 2) {
      // No: Orange
      return {
        bg: "bg-orange-50",
        text: "text-orange-700",
        ring: "ring-orange-700/10"
      };
    } else if (ratingValue === 1) {
      // Strong No: Red
      return {
        bg: "bg-red-50",
        text: "text-red-700",
        ring: "ring-red-700/10"
      };
    } else {
      // Default style for any other values
      return {
        bg: "bg-gray-50",
        text: "text-gray-700",
        ring: "ring-gray-700/10"
      };
    }
  };

  // Helper function to get rating label
  const getRatingLabel = (rating) => {
    if (!rating) return null;

    const ratingValue = parseFloat(rating);
    if (ratingValue === 5) return "Strong Yes";
    if (ratingValue === 4) return "Yes";
    if (ratingValue === 3) return "Neutral";
    if (ratingValue === 2) return "No";
    if (ratingValue === 1) return "Strong No";
    return null;
  };

  const aiRatingItems = [
    {
      id: uuidv4(),
      label: 'Strong Yes',
      onClick: () => {
        const styles = getRatingBadgeStyles(5);
        const newFilter = {
          id: uuidv4(),
          label: 'AI rating',
          value: 'Strong Yes',
          icon: <span className={`inline-flex items-center rounded-md px-2 py-1 text-xs font-medium ${styles.bg} ${styles.text} ${styles.ring} ring-1 ring-inset`}>
            {/* <span className="inline-block w-2 h-2 rounded-full bg-green-500 mr-1"></span> */}
            <svg
              xmlns="http://www.w3.org/2000/svg"
              fill="none"
              viewBox="0 0 24 24"
              strokeWidth="1.5"
              stroke="currentColor"
              aria-hidden="true"
              data-slot="icon"
              className="w-3 h-3"
            >
              <path
                strokeLinecap="round"
                strokeLinejoin="round"
                d="M9.813 15.904 9 18.75l-.813-2.846a4.5 4.5 0 0 0-3.09-3.09L2.25 12l2.846-.813a4.5 4.5 0 0 0 3.09-3.09L9 5.25l.813 2.846a4.5 4.5 0 0 0 3.09 3.09L15.75 12l-2.846.813a4.5 4.5 0 0 0-3.09 3.09ZM18.259 8.715 18 9.75l-.259-1.035a3.375 3.375 0 0 0-2.455-2.456L14.25 6l1.036-.259a3.375 3.375 0 0 0 2.455-2.456L18 2.25l.259 1.035a3.375 3.375 0 0 0 2.456 2.456L21.75 6l-1.035.259a3.375 3.375 0 0 0-2.456 2.456ZM16.894 20.567 16.5 21.75l-.394-1.183a2.25 2.25 0 0 0-1.423-1.423L13.5 18.75l1.183-.394a2.25 2.25 0 0 0 1.423-1.423l.394-1.183.394 1.183a2.25 2.25 0 0 0 1.423 1.423l1.183.394-1.183.394a2.25 2.25 0 0 0-1.423 1.423Z"
              />
            </svg>
          </span>
        };

        setActiveFilters((prevFilters) => ({
          ...prevFilters,
          'AI rating': [...(prevFilters['AI rating'] || []), newFilter]
        }));

        setAiRatingMenuOpen(false);
        setAiRatingSearchQuery("");
        clearPaginationFromState();
      },
    },
    {
      id: uuidv4(),
      label: 'Yes',
      onClick: () => {
        const styles = getRatingBadgeStyles(4);
        const newFilter = {
          id: uuidv4(),
          label: 'AI rating',
          value: 'Yes',
          icon: <span className={`inline-flex items-center rounded-md px-2 py-1 text-xs font-medium ${styles.bg} ${styles.text} ${styles.ring} ring-1 ring-inset`}>
            {/* <span className="inline-block w-2 h-2 rounded-full bg-emerald-500 mr-1"></span> */}
            <svg
              xmlns="http://www.w3.org/2000/svg"
              fill="none"
              viewBox="0 0 24 24"
              strokeWidth="1.5"
              stroke="currentColor"
              aria-hidden="true"
              data-slot="icon"
              className="w-3 h-3"
            >
              <path
                strokeLinecap="round"
                strokeLinejoin="round"
                d="M9.813 15.904 9 18.75l-.813-2.846a4.5 4.5 0 0 0-3.09-3.09L2.25 12l2.846-.813a4.5 4.5 0 0 0 3.09-3.09L9 5.25l.813 2.846a4.5 4.5 0 0 0 3.09 3.09L15.75 12l-2.846.813a4.5 4.5 0 0 0-3.09 3.09ZM18.259 8.715 18 9.75l-.259-1.035a3.375 3.375 0 0 0-2.455-2.456L14.25 6l1.036-.259a3.375 3.375 0 0 0 2.455-2.456L18 2.25l.259 1.035a3.375 3.375 0 0 0 2.456 2.456L21.75 6l-1.035.259a3.375 3.375 0 0 0-2.456 2.456ZM16.894 20.567 16.5 21.75l-.394-1.183a2.25 2.25 0 0 0-1.423-1.423L13.5 18.75l1.183-.394a2.25 2.25 0 0 0 1.423-1.423l.394-1.183.394 1.183a2.25 2.25 0 0 0 1.423 1.423l1.183.394-1.183.394a2.25 2.25 0 0 0-1.423 1.423Z"
              />
            </svg>
          </span>
        };

        setActiveFilters((prevFilters) => ({
          ...prevFilters,
          'AI rating': [...(prevFilters['AI rating'] || []), newFilter]
        }));

        setAiRatingMenuOpen(false);
        setAiRatingSearchQuery("");
        clearPaginationFromState();
      },
    },
    {
      id: uuidv4(),
      label: 'Neutral',
      onClick: () => {
        const styles = getRatingBadgeStyles(3);
        const newFilter = {
          id: uuidv4(),
          label: 'AI rating',
          value: 'Neutral',
          icon: <span className={`inline-flex items-center rounded-md px-2 py-1 text-xs font-medium ${styles.bg} ${styles.text} ${styles.ring} ring-1 ring-inset`}>
            {/* <span className="inline-block w-2 h-2 rounded-full bg-blue-500 mr-1"></span> */}
            <svg
              xmlns="http://www.w3.org/2000/svg"
              fill="none"
              viewBox="0 0 24 24"
              strokeWidth="1.5"
              stroke="currentColor"
              aria-hidden="true"
              data-slot="icon"
              className="w-3 h-3"
            >
              <path
                strokeLinecap="round"
                strokeLinejoin="round"
                d="M9.813 15.904 9 18.75l-.813-2.846a4.5 4.5 0 0 0-3.09-3.09L2.25 12l2.846-.813a4.5 4.5 0 0 0 3.09-3.09L9 5.25l.813 2.846a4.5 4.5 0 0 0 3.09 3.09L15.75 12l-2.846.813a4.5 4.5 0 0 0-3.09 3.09ZM18.259 8.715 18 9.75l-.259-1.035a3.375 3.375 0 0 0-2.455-2.456L14.25 6l1.036-.259a3.375 3.375 0 0 0 2.455-2.456L18 2.25l.259 1.035a3.375 3.375 0 0 0 2.456 2.456L21.75 6l-1.035.259a3.375 3.375 0 0 0-2.456 2.456ZM16.894 20.567 16.5 21.75l-.394-1.183a2.25 2.25 0 0 0-1.423-1.423L13.5 18.75l1.183-.394a2.25 2.25 0 0 0 1.423-1.423l.394-1.183.394 1.183a2.25 2.25 0 0 0 1.423 1.423l1.183.394-1.183.394a2.25 2.25 0 0 0-1.423 1.423Z"
              />
            </svg>
          </span>
        };

        setActiveFilters((prevFilters) => ({
          ...prevFilters,
          'AI rating': [...(prevFilters['AI rating'] || []), newFilter]
        }));

        setAiRatingMenuOpen(false);
        setAiRatingSearchQuery("");
        clearPaginationFromState();
      },
    },
    {
      id: uuidv4(),
      label: 'No',
      onClick: () => {
        const styles = getRatingBadgeStyles(2);
        const newFilter = {
          id: uuidv4(),
          label: 'AI rating',
          value: 'No',
          icon: <span className={`inline-flex items-center rounded-md px-2 py-1 text-xs font-medium ${styles.bg} ${styles.text} ${styles.ring} ring-1 ring-inset`}>
            {/* <span className="inline-block w-2 h-2 rounded-full bg-orange-500 mr-1"></span> */}
            <svg
              xmlns="http://www.w3.org/2000/svg"
              fill="none"
              viewBox="0 0 24 24"
              strokeWidth="1.5"
              stroke="currentColor"
              aria-hidden="true"
              data-slot="icon"
              className="w-3 h-3"
            >
              <path
                strokeLinecap="round"
                strokeLinejoin="round"
                d="M9.813 15.904 9 18.75l-.813-2.846a4.5 4.5 0 0 0-3.09-3.09L2.25 12l2.846-.813a4.5 4.5 0 0 0 3.09-3.09L9 5.25l.813 2.846a4.5 4.5 0 0 0 3.09 3.09L15.75 12l-2.846.813a4.5 4.5 0 0 0-3.09 3.09ZM18.259 8.715 18 9.75l-.259-1.035a3.375 3.375 0 0 0-2.455-2.456L14.25 6l1.036-.259a3.375 3.375 0 0 0 2.455-2.456L18 2.25l.259 1.035a3.375 3.375 0 0 0 2.456 2.456L21.75 6l-1.035.259a3.375 3.375 0 0 0-2.456 2.456ZM16.894 20.567 16.5 21.75l-.394-1.183a2.25 2.25 0 0 0-1.423-1.423L13.5 18.75l1.183-.394a2.25 2.25 0 0 0 1.423-1.423l.394-1.183.394 1.183a2.25 2.25 0 0 0 1.423 1.423l1.183.394-1.183.394a2.25 2.25 0 0 0-1.423 1.423Z"
              />
            </svg>
          </span>
        };

        setActiveFilters((prevFilters) => ({
          ...prevFilters,
          'AI rating': [...(prevFilters['AI rating'] || []), newFilter]
        }));

        setAiRatingMenuOpen(false);
        setAiRatingSearchQuery("");
        clearPaginationFromState();
      },
    },
    {
      id: uuidv4(),
      label: 'Strong No',
      onClick: () => {
        const styles = getRatingBadgeStyles(1);
        const newFilter = {
          id: uuidv4(),
          label: 'AI rating',
          value: 'Strong No',
          icon: <span className={`inline-flex items-center rounded-md px-2 py-1 text-xs font-medium ${styles.bg} ${styles.text} ${styles.ring} ring-1 ring-inset`}>
            {/* <span className="inline-block w-2 h-2 rounded-full bg-red-500 mr-1"></span> */}
            <svg
              xmlns="http://www.w3.org/2000/svg"
              fill="none"
              viewBox="0 0 24 24"
              strokeWidth="1.5"
              stroke="currentColor"
              aria-hidden="true"
              data-slot="icon"
              className="w-3 h-3"
            >
              <path
                strokeLinecap="round"
                strokeLinejoin="round"
                d="M9.813 15.904 9 18.75l-.813-2.846a4.5 4.5 0 0 0-3.09-3.09L2.25 12l2.846-.813a4.5 4.5 0 0 0 3.09-3.09L9 5.25l.813 2.846a4.5 4.5 0 0 0 3.09 3.09L15.75 12l-2.846.813a4.5 4.5 0 0 0-3.09 3.09ZM18.259 8.715 18 9.75l-.259-1.035a3.375 3.375 0 0 0-2.455-2.456L14.25 6l1.036-.259a3.375 3.375 0 0 0 2.455-2.456L18 2.25l.259 1.035a3.375 3.375 0 0 0 2.456 2.456L21.75 6l-1.035.259a3.375 3.375 0 0 0-2.456 2.456ZM16.894 20.567 16.5 21.75l-.394-1.183a2.25 2.25 0 0 0-1.423-1.423L13.5 18.75l1.183-.394a2.25 2.25 0 0 0 1.423-1.423l.394-1.183.394 1.183a2.25 2.25 0 0 0 1.423 1.423l1.183.394-1.183.394a2.25 2.25 0 0 0-1.423 1.423Z"
              />
            </svg>

          </span>
        };

        setActiveFilters((prevFilters) => ({
          ...prevFilters,
          'AI rating': [...(prevFilters['AI rating'] || []), newFilter]
        }));

        setAiRatingMenuOpen(false);
        setAiRatingSearchQuery("");
        clearPaginationFromState();
      },
    }


  ];

  // user rating 
  const getSkillScaleBadgeStyles = (label: string): { bg: string; text: string; ring: string } => {
    switch (label) {
      case 'Strong Yes':
        return {
          bg: "bg-green-50",
          text: "text-green-700",
          ring: "ring-green-700/10"
        };
      case 'Yes':
        return {
          bg: "bg-blue-50",
          text: "text-blue-700",
          ring: "ring-blue-700/10"
        }; // Using emerald for 'Yes'
      case 'Neutral':
        return {
          bg: "bg-yellow-50",
          text: "text-yellow-700",
          ring: "ring-yellow-700/10"
        };
      case 'No':
        return {
          bg: "bg-gray-50",
          text: "text-gray-700",
          ring: "ring-gray-700/10"
        };
      case 'Strong No':
        return {
          bg: "bg-red-50",
          text: "text-red-700",
          ring: "ring-red-700/10"
        };
      default: // Fallback for unknown labels
        return {
          bg: "bg-gray-50",
          text: "text-gray-700",
          ring: "ring-gray-700/10"
        };
    }
  };

  // Function to get skill level label based on scale value
  const getSkillLevelLabel = (scale: any) => {
    const scaleValue = parseFloat(scale);
    if (scaleValue >= 3.5 && scaleValue <= 4.0) return "Strong Yes";
    if (scaleValue >= 1.5 && scaleValue <= 3.4) return "Yes";
    if (scaleValue >= 0.5 && scaleValue <= 1.4) return "Neutral";
    if (scaleValue >= -1.5 && scaleValue <= 0.4) return "No";
    if (scaleValue >= -2.0 && scaleValue <= -1.6) return "Strong No";

    return null;
  };


  const userRatingItems = [
    {
      id: uuidv4(),
      label: 'Strong Yes',
      onClick: () => {
        const itemLabel = 'Strong Yes';
        const styles = getSkillScaleBadgeStyles(itemLabel);
        const newFilter = {
          id: uuidv4(),
          label: 'User rating',
          value: itemLabel,
          icon: <span className={`inline-flex items-center rounded-md px-2 py-1 text-xs font-medium ${styles.bg} ${styles.text} ${styles.ring} ring-1 ring-inset`}>
            <svg
              xmlns="http://www.w3.org/2000/svg"
              fill="none"
              viewBox="0 0 24 24"
              strokeWidth="1.5"
              stroke="currentColor"
              aria-hidden="true"
              data-slot="icon"
              className="w-3 h-3"
            >
              <path
                strokeLinecap="round"
                strokeLinejoin="round"
                d="M9.813 15.904 9 18.75l-.813-2.846a4.5 4.5 0 0 0-3.09-3.09L2.25 12l2.846-.813a4.5 4.5 0 0 0 3.09-3.09L9 5.25l.813 2.846a4.5 4.5 0 0 0 3.09 3.09L15.75 12l-2.846.813a4.5 4.5 0 0 0-3.09 3.09ZM18.259 8.715 18 9.75l-.259-1.035a3.375 3.375 0 0 0-2.455-2.456L14.25 6l1.036-.259a3.375 3.375 0 0 0 2.455-2.456L18 2.25l.259 1.035a3.375 3.375 0 0 0 2.456 2.456L21.75 6l-1.035.259a3.375 3.375 0 0 0-2.456 2.456ZM16.894 20.567 16.5 21.75l-.394-1.183a2.25 2.25 0 0 0-1.423-1.423L13.5 18.75l1.183-.394a2.25 2.25 0 0 0 1.423-1.423l.394-1.183.394 1.183a2.25 2.25 0 0 0 1.423 1.423l1.183.394-1.183.394a2.25 2.25 0 0 0-1.423 1.423Z"
              />
            </svg>
          </span>
        };
        setActiveFilters((prevFilters) => ({
          ...prevFilters,
          'User rating': [...(prevFilters['User rating'] || []), newFilter]
        }));
        setUserRatingMenuOpen(false);
        setUserRatingSearchQuery("");
        clearPaginationFromState();
      },
    },
    {
      id: uuidv4(),
      label: 'Yes',
      onClick: () => {
        const itemLabel = 'Yes';
        const styles = getSkillScaleBadgeStyles(itemLabel);
        const newFilter = {
          id: uuidv4(),
          label: 'User rating',
          value: itemLabel,
          icon: <span className={`inline-flex items-center rounded-md px-2 py-1 text-xs font-medium ${styles.bg} ${styles.text} ${styles.ring} ring-1 ring-inset`}>
            {/* {itemLabel} */}
            <svg
              xmlns="http://www.w3.org/2000/svg"
              fill="none"
              viewBox="0 0 24 24"
              strokeWidth="1.5"
              stroke="currentColor"
              aria-hidden="true"
              data-slot="icon"
              className="w-3 h-3"
            >
              <path
                strokeLinecap="round"
                strokeLinejoin="round"
                d="M9.813 15.904 9 18.75l-.813-2.846a4.5 4.5 0 0 0-3.09-3.09L2.25 12l2.846-.813a4.5 4.5 0 0 0 3.09-3.09L9 5.25l.813 2.846a4.5 4.5 0 0 0 3.09 3.09L15.75 12l-2.846.813a4.5 4.5 0 0 0-3.09 3.09ZM18.259 8.715 18 9.75l-.259-1.035a3.375 3.375 0 0 0-2.455-2.456L14.25 6l1.036-.259a3.375 3.375 0 0 0 2.455-2.456L18 2.25l.259 1.035a3.375 3.375 0 0 0 2.456 2.456L21.75 6l-1.035.259a3.375 3.375 0 0 0-2.456 2.456ZM16.894 20.567 16.5 21.75l-.394-1.183a2.25 2.25 0 0 0-1.423-1.423L13.5 18.75l1.183-.394a2.25 2.25 0 0 0 1.423-1.423l.394-1.183.394 1.183a2.25 2.25 0 0 0 1.423 1.423l1.183.394-1.183.394a2.25 2.25 0 0 0-1.423 1.423Z"
              />
            </svg>
          </span>
        };
        setActiveFilters((prevFilters) => ({
          ...prevFilters,
          'User rating': [...(prevFilters['User rating'] || []), newFilter]
        }));
        setUserRatingMenuOpen(false);
        setUserRatingSearchQuery("");
        clearPaginationFromState();
      },
    },
    {
      id: uuidv4(),
      label: 'Neutral',
      onClick: () => {
        const itemLabel = 'Neutral';
        const styles = getSkillScaleBadgeStyles(itemLabel);
        const newFilter = {
          id: uuidv4(),
          label: 'User rating',
          value: itemLabel,
          icon: <span className={`inline-flex items-center rounded-md px-2 py-1 text-xs font-medium ${styles.bg} ${styles.text} ${styles.ring} ring-1 ring-inset`}>
            <svg
              xmlns="http://www.w3.org/2000/svg"
              fill="none"
              viewBox="0 0 24 24"
              strokeWidth="1.5"
              stroke="currentColor"
              aria-hidden="true"
              data-slot="icon"
              className="w-3 h-3"
            >
              <path
                strokeLinecap="round"
                strokeLinejoin="round"
                d="M9.813 15.904 9 18.75l-.813-2.846a4.5 4.5 0 0 0-3.09-3.09L2.25 12l2.846-.813a4.5 4.5 0 0 0 3.09-3.09L9 5.25l.813 2.846a4.5 4.5 0 0 0 3.09 3.09L15.75 12l-2.846.813a4.5 4.5 0 0 0-3.09 3.09ZM18.259 8.715 18 9.75l-.259-1.035a3.375 3.375 0 0 0-2.455-2.456L14.25 6l1.036-.259a3.375 3.375 0 0 0 2.455-2.456L18 2.25l.259 1.035a3.375 3.375 0 0 0 2.456 2.456L21.75 6l-1.035.259a3.375 3.375 0 0 0-2.456 2.456ZM16.894 20.567 16.5 21.75l-.394-1.183a2.25 2.25 0 0 0-1.423-1.423L13.5 18.75l1.183-.394a2.25 2.25 0 0 0 1.423-1.423l.394-1.183.394 1.183a2.25 2.25 0 0 0 1.423 1.423l1.183.394-1.183.394a2.25 2.25 0 0 0-1.423 1.423Z"
              />
            </svg>
          </span>
        };
        setActiveFilters((prevFilters) => ({
          ...prevFilters,
          'User rating': [...(prevFilters['User rating'] || []), newFilter]
        }));
        setUserRatingMenuOpen(false);
        setUserRatingSearchQuery("");
        clearPaginationFromState();
      },
    },
    {
      id: uuidv4(),
      label: 'No',
      onClick: () => {
        const itemLabel = 'No';
        const styles = getSkillScaleBadgeStyles(itemLabel);
        const newFilter = {
          id: uuidv4(),
          label: 'User rating',
          value: itemLabel,
          icon: <span className={`inline-flex items-center rounded-md px-2 py-1 text-xs font-medium ${styles.bg} ${styles.text} ${styles.ring} ring-1 ring-inset`}>
            <svg
              xmlns="http://www.w3.org/2000/svg"
              fill="none"
              viewBox="0 0 24 24"
              strokeWidth="1.5"
              stroke="currentColor"
              aria-hidden="true"
              data-slot="icon"
              className="w-3 h-3"
            >
              <path
                strokeLinecap="round"
                strokeLinejoin="round"
                d="M9.813 15.904 9 18.75l-.813-2.846a4.5 4.5 0 0 0-3.09-3.09L2.25 12l2.846-.813a4.5 4.5 0 0 0 3.09-3.09L9 5.25l.813 2.846a4.5 4.5 0 0 0 3.09 3.09L15.75 12l-2.846.813a4.5 4.5 0 0 0-3.09 3.09ZM18.259 8.715 18 9.75l-.259-1.035a3.375 3.375 0 0 0-2.455-2.456L14.25 6l1.036-.259a3.375 3.375 0 0 0 2.455-2.456L18 2.25l.259 1.035a3.375 3.375 0 0 0 2.456 2.456L21.75 6l-1.035.259a3.375 3.375 0 0 0-2.456 2.456ZM16.894 20.567 16.5 21.75l-.394-1.183a2.25 2.25 0 0 0-1.423-1.423L13.5 18.75l1.183-.394a2.25 2.25 0 0 0 1.423-1.423l.394-1.183.394 1.183a2.25 2.25 0 0 0 1.423 1.423l1.183.394-1.183.394a2.25 2.25 0 0 0-1.423 1.423Z"
              />
            </svg>
          </span>
        };
        setActiveFilters((prevFilters) => ({
          ...prevFilters,
          'User rating': [...(prevFilters['User rating'] || []), newFilter]
        }));
        setUserRatingMenuOpen(false);
        setUserRatingSearchQuery("");
        clearPaginationFromState();
      },
    },
    {
      id: uuidv4(),
      label: 'Strong No', // Label used as key for styles
      onClick: () => {
        const itemLabel = 'Strong No'; // Explicitly use the label
        const styles = getSkillScaleBadgeStyles(itemLabel); // Get styles based on label
        const newFilter = {
          id: uuidv4(),
          label: 'User rating',
          value: itemLabel,
          icon: <span className={`inline-flex items-center rounded-md px-2 py-1 text-xs font-medium ${styles.bg} ${styles.text} ${styles.ring} ring-1 ring-inset`}>
            <svg
              xmlns="http://www.w3.org/2000/svg"
              fill="none"
              viewBox="0 0 24 24"
              strokeWidth="1.5"
              stroke="currentColor"
              aria-hidden="true"
              data-slot="icon"
              className="w-3 h-3"
            >
              <path
                strokeLinecap="round"
                strokeLinejoin="round"
                d="M9.813 15.904 9 18.75l-.813-2.846a4.5 4.5 0 0 0-3.09-3.09L2.25 12l2.846-.813a4.5 4.5 0 0 0 3.09-3.09L9 5.25l.813 2.846a4.5 4.5 0 0 0 3.09 3.09L15.75 12l-2.846.813a4.5 4.5 0 0 0-3.09 3.09ZM18.259 8.715 18 9.75l-.259-1.035a3.375 3.375 0 0 0-2.455-2.456L14.25 6l1.036-.259a3.375 3.375 0 0 0 2.455-2.456L18 2.25l.259 1.035a3.375 3.375 0 0 0 2.456 2.456L21.75 6l-1.035.259a3.375 3.375 0 0 0-2.456 2.456ZM16.894 20.567 16.5 21.75l-.394-1.183a2.25 2.25 0 0 0-1.423-1.423L13.5 18.75l1.183-.394a2.25 2.25 0 0 0 1.423-1.423l.394-1.183.394 1.183a2.25 2.25 0 0 0 1.423 1.423l1.183.394-1.183.394a2.25 2.25 0 0 0-1.423 1.423Z"
              />
            </svg>
          </span>
        };
        setActiveFilters((prevFilters) => ({
          ...prevFilters,
          'User rating': [...(prevFilters['User rating'] || []), newFilter]
        }));
        setUserRatingMenuOpen(false);
        setUserRatingSearchQuery("");
        clearPaginationFromState();
      },
    }



  ]

  // create by
  const createdItems = [
    {
      id: uuidv4(),
      label: '2 days ago',
      onClick: () => {
        setActiveFilters([...activeFilters, { id: uuidv4(), label: 'Created at', icon: <span>🗓️</span>, value: '2 days ago' }]);
        setCreatedMenuOpen(false);
        setCreatedSearchQuery("");
      },
    },
    {
      id: uuidv4(),
      label: '3 days ago',
      onClick: () => {
        setActiveFilters([...activeFilters, { id: uuidv4(), label: 'Created at', icon: <span>🗓️</span>, value: '3 days ago' }]);
        setCreatedMenuOpen(false);
        setCreatedSearchQuery("");
      },
    },
    {
      id: uuidv4(),
      label: '4 days ago',
      onClick: () => {
        setActiveFilters([...activeFilters, { id: uuidv4(), label: 'Created at', icon: <span>🗓️</span>, value: '4 days ago' }]);
        setCreatedMenuOpen(false);
        setCreatedSearchQuery("");
      },
    },
    {
      id: uuidv4(),
      label: '5 days ago',
      onClick: () => {
        setActiveFilters([...activeFilters, { id: uuidv4(), label: 'Created at', icon: <span>🗓️</span>, value: '5 days ago' }]);
        setCreatedMenuOpen(false);
        setCreatedSearchQuery("");
      },
    },
  ];



  const handleMainMenuClick = () => {
    setIsMainMenuOpen(!isMainMenuOpen);
    setBoardsMenuOpen(false)
    setUpdatedMenuOpen(false)
    setCreatedMenuOpen(false)
    setSortMenuOpen(false)
    setAiRatingMenuOpen(false)
    setUserRatingMenuOpen(false)
  };



  // const removeFilter = (filterId: string) => {
  //   setActiveFilters(prevFilters => prevFilters.filter(filter => filter.id !== filterId));
  // };

  // Filter sort options based on search query
  const filteredSortOptions = sortOptions.filter(item =>
    item.label.toLowerCase().includes(sortSearchQuery.toLowerCase())
  );

  const filteredBoardsItems = boardsItems.filter(item =>
    item.label.toLowerCase().includes(boardsSearchQuery.toLowerCase())
  );

  const filterdAiRatingItems = aiRatingItems.filter(item =>
    item.label.toLowerCase().includes(aiRatingSearchQuery.toLowerCase())
  );

  const filteredUserRatingItems = userRatingItems.filter(item =>
    item.label.toLowerCase().includes(userRatingSearchQuery.toLowerCase())
  );


  const filteredCreatedItems = createdItems.filter(item =>
    item.label.toLowerCase().includes(createdSearchQuery.toLowerCase())
  );

  const filteredMainItems = mainItems.filter(item =>
    item.label.toLowerCase().includes(searchQuery.toLowerCase())
  );

  const removeFilter = (category, id) => {
    if (category === 'search') {
      clearAll();
      setActiveFilters((prevFilters) => ({
        ...prevFilters,
        search: ''
      }));
    } else {
      setActiveFilters((prevFilters) => ({
        ...prevFilters,
        [category]: (prevFilters[category] || []).filter((filter) => filter.id !== id)
      }));
    }
  };

  useEffect(() => {
    if (selectedValuesRef.current) {
      setSectionHeight(selectedValuesRef.current.offsetHeight);
    } else {
      setSectionHeight(0);
    }
  }, [activeFilters]);


  const handleClearAll = () => {
    clearAll(); // This will clear the searchTerm in context
    setActiveFilters({
      Stages: [],
      'Created at': [],
      'Updated By': [],
      'Sort': [],
      'AI rating': [],
      'User rating': [],
      search: '',
      pagination: {
        pageIndex: 0,
        pageSize: 25,
        currentPage: 1
      }
    });
    localStorage.removeItem('activeFiltersBookmark');
    // Re-initialize with default pagination
    localStorage.setItem('activeFiltersBookmark', JSON.stringify({
      Stages: [],
      'Created at': [],
      'Updated By': [],
      search: '',
      'AI rating': [],
      'User rating': [],
      'Sort': [],
      pagination: {
        pageIndex: 0,
        pageSize: 25,
        currentPage: 1
      }
    }));
  };


  const FilterButton: React.FC<FilterButtonProps> = ({ label, onClick, activeFilters }) => {
    const totalActiveFilters = activeFilters
      ? Object.values(activeFilters).reduce((acc, filters) => acc + filters.length, 0)
      : 0;

    const isActive = totalActiveFilters > 0;

    const buttonClassName = `
      ml-0 lg:ml-[0.5rem] 
      flex items-center gap-[0.4rem] md:gap-[0.5rem] lg:gap-[0.5rem] 
      rounded-md py-[6px] px-[0.5rem] 
      text-[12px] md:text-[0.8125rem] lg:text-[0.8125rem] 
      font-semibold
      transition-colors duration-200
      ${isActive
        ? 'bg-blue-500 text-white hover:bg-blue-600'
        : 'bg-white text-dark-black-100 hover:bg-light-gray-100'}
    `;


    return (
      <button
        type="button"
        className={`ml-0 lg:ml-[0rem] flex items-center gap-[0.4rem] md:gap-[0.5rem] lg:gap-[0.5rem] rounded-md h-[30px] py-[6px] px-[0.5rem] hover:bg-light-gray-100 text-[12px] md:text-[0.8125rem] lg:text-[0.8125rem] ${hasActiveFilters ? 'text-red' : 'text-dark-black-100'
          }`}
        onClick={onClick}
      >
        <svg
          stroke="currentColor"
          fill="none"
          strokeWidth="2"
          viewBox="0 0 24 24"
          strokeLinecap="round"
          strokeLinejoin="round"
          aria-hidden="true"
          focusable="false"
          height="1em"
          width="1em"
          className={hasActiveFilters ? '#text-[#111827] ' : 'text-[#0000007a]'}
          xmlns="http://www.w3.org/2000/svg"
        >
          <polygon points="22 3 2 3 10 12.46 10 19 14 21 14 12.46 22 3"></polygon>
        </svg>
        <span
          className={hasActiveFilters ? '#text-[#111827] leading-[1.2] text-[12px] md:text-[0.8125rem] lg:text-[0.8125rem] font-semibold' : 'text-[#0000007a]  leading-[1.2] text-[12px] md:text-[0.8125rem] lg:text-[0.8125rem] font-semibold'}
        >
          {label}
        </span>
      </button>
    );
  };



  const handleTagChange = (newValue) => {
    setSelectedTags(newValue);
  };



  const boardsMenuRef = useRef(null)
  const statusMenuRef = useRef(null);
  const subStatusMenuRef = useRef(null);
  const tagsMenuRef = useRef(null);
  const assignMenuRef = useRef(null);
  const priorityMenuRef = useRef(null);
  const sentimentMenuRef = useRef(null);
  const createdMenuRef = useRef(null);
  const updatedMenuRef = useRef(null)
  const mainMenuRef = useRef(null);

  const handleClickOutside = (event) => {
    if (boardsMenuRef.current && !boardsMenuRef.current.contains(event.target)) {
      setBoardsMenuOpen(false);
    }
    if (createdMenuRef.current && !createdMenuRef.current.contains(event.target)) {
      setCreatedMenuOpen(false);
    }
    if (updatedMenuRef.current && !updatedMenuRef.current.contains(event.target)) {
      setUpdatedMenuOpen(false);
    }
    if (mainMenuRef.current && !mainMenuRef.current.contains(event.target)) {
      setIsMainMenuOpen(false);
    }
    if (sortMenuRef.current && !sortMenuRef.current.contains(event.target)) {
      setSortMenuOpen(false);
    }
    if (aiRatingMenuRef.current && !aiRatingMenuRef.current.contains(event.target)) {
      setAiRatingMenuOpen(false);
    }
    if (userRatingMenuRef.current && !userRatingMenuRef.current.contains(event.target)) {
      setUserRatingMenuOpen(false);
    }
  };

  useEffect(() => {
    document.addEventListener('mousedown', handleClickOutside);
    return () => {
      document.removeEventListener('mousedown', handleClickOutside);
    };
  }, []);

  // created at
  const [value, setValue] = useState({
    startDate: null,
    endDate: null
  });
  const [updateValue, setUpdateValue] = useState({
    startDate: null,
    endDate: null
  });


  // const handleValueChange = (newValue) => {
  //   if (newValue.startDate && newValue.endDate) {
  //     const formattedStartDate = format(new Date(newValue.startDate), 'd MMMM yyyy');
  //     const formattedEndDate = format(new Date(newValue.endDate), 'd MMMM yyyy');
  //   }  
  //   setValue(newValue);
  // }
  const handleValueChange = (newValue) => {

    if (newValue.startDate && newValue.endDate) {
      const formattedStartDate = format(new Date(newValue.startDate), 'd MMMM yyyy');
      const formattedEndDate = format(new Date(newValue.endDate), 'd MMMM yyyy');

      const dateFilter = {
        id: 'date-range',
        label: 'Date Range',
        value: `${formattedStartDate} - ${formattedEndDate}`,
        icon: null, // Add an icon if needed
      };

      setActiveFilters((prevFilters) => ({
        ...prevFilters,
        ['Created at']: [dateFilter], // Replace existing date range filter
      }));
    }
    clearPaginationFromState();
    setValue(newValue);
    setCreatedMenuOpen(false);

  }

  const handleUpdatedValueChange = (newValue) => {

    if (newValue.startDate && newValue.endDate) {
      const formattedStartDate = format(new Date(newValue.startDate), 'd MMMM yyyy');
      const formattedEndDate = format(new Date(newValue.endDate), 'd MMMM yyyy');

      const dateFilter = {
        id: 'date-range',
        label: 'Date Range',
        value: `${formattedStartDate} - ${formattedEndDate}`,
        icon: null, // Add an icon if needed
      };

      setActiveFilters((prevFilters) => ({
        ...prevFilters,
        ['Updated at']: [dateFilter], // Replace existing date range filter
      }));
    }
    clearPaginationFromState();
    setUpdateValue(newValue);
    setUpdatedMenuOpen(false);

  }
  const [openCategoryMenu, setOpenCategoryMenu] = useState(null);



  // New function to handle updating a specific filter
  const handleValueClick = (category, id) => {
    setOpenCategoryMenu(category);
    setEditingFilter({ category, id });
    setBoardsMenuOpen(category === 'Stages');
    setCreatedMenuOpen(category === 'Created at');
    setUpdatedMenuOpen(category === 'Updated at');
    setSortMenuOpen(category === 'Sort');
    setAiRatingMenuOpen(category === 'AI rating');
    setUserRatingMenuOpen(category === 'User rating');
  };

  const renderIcon = (icon) => {
    if (icon && icon.type && icon.props) {
      return React.createElement(icon.type, icon.props);
    }

    return null;
  };

  // New function to handle updating a specific filter
  // const handleFilterUpdate = (category, oldId, newId, newValue, newIcon) => {
  //   setActiveFilters((prevFilters) => ({
  //     ...prevFilters,
  //     [category]: prevFilters[category].map(filter =>
  //       filter.id === oldId ? { ...filter, id: newId, value: newValue, icon: { type: newIcon.type, props: newIcon.props } } : filter

  //     )
  //   }));
  //   setOpenCategoryMenu(null);
  //   setEditingFilter(null);
  //   setBoardsMenuOpen(false);
  //   setCreatedMenuOpen(false);
  //   setUpdatedMenuOpen(false);

  // };

  const handleFilterUpdate = (category, oldId, newId, newValue, newIcon) => {
    setActiveFilters((prevFilters) => ({
      ...prevFilters,
      [category]: [{ id: newId, value: newValue, icon: { type: newIcon.type, props: newIcon.props } }] // Only keep the new filter
    }));
    setOpenCategoryMenu(null);
    setEditingFilter(null);
    setBoardsMenuOpen(false);
    setCreatedMenuOpen(false);
    setUpdatedMenuOpen(false);
    setSortMenuOpen(false)
    setAiRatingMenuOpen(false);
    setUserRatingMenuOpen(false);

  };

  // Set activeFilters to local storage

  useEffect(() => {
    localStorage.setItem('activeFiltersBookmark', JSON.stringify(activeFilters));
  }, [activeFilters]);

  const clearPaginationFromState = () => {
    window.dispatchEvent(new CustomEvent('paginationresetsetate'));
  };


  // const handleFileChange = (event) => {
  //   const file = event.target.files[0];
  //   if (file) {
  //     // Validate file type
  //     const allowedTypes = ['application/pdf', 'application/msword', 'application/vnd.openxmlformats-officedocument.wordprocessingml.document'];
  //     if (!allowedTypes.includes(file.type)) {
  //       toast.error("Only PDF or DOC files are allowed.");
  //       return;
  //     }

  //     // Validate file size (20 MB limit)
  //     const maxSize = 20 * 1024 * 1024; // 20 MB in bytes
  //     if (file.size > maxSize) {
  //       toast.error("File size must be less than 20 MB.");
  //       return;
  //     }

  //     setSelectedFile(file);
  //   }
  // };

  // const removeFile = () => {
  //   setSelectedFile(null);
  // };


  const handleFileChange = (event: React.ChangeEvent<HTMLInputElement>) => {
    const fileList = event.target.files;
    if (!fileList) return;

    const newFiles = Array.from(fileList);

    if (newFiles.length === 0) return;

    // Check if adding new files would exceed the 10 file limit
    if (selectedFiles.length + newFiles.length > 10) {
      toast.error("You can upload a maximum of 10 files.");
      return;
    }

    // Validate each file
    const validFiles = newFiles.filter(file => {
      // Validate file type
      const allowedTypes = ['application/pdf', 'application/msword', 'application/vnd.openxmlformats-officedocument.wordprocessingml.document'];
      if (!allowedTypes.includes(file.type)) {
        toast.error(`${file.name}: Only PDF or DOC files are allowed.`);
        return false;
      }

      // Validate file size (20 MB limit)
      const maxSize = 20 * 1024 * 1024; // 20 MB in bytes
      if (file.size > maxSize) {
        toast.error(`${file.name}: File size must be less than 20 MB.`);
        return false;
      }

      return true;
    });

    // Add valid files to the existing files array
    setSelectedFiles(prevFiles => [...prevFiles, ...validFiles]);
  };

  const removeFile = (index: number) => {
    setSelectedFiles(prevFiles => prevFiles.filter((_, i) => i !== index));
  };

  const handleUploadModal = () => {
    setUploadModal(true);
  };

  const handleDragOver = (e: React.DragEvent<HTMLDivElement>) => {
    e.preventDefault();
    setIsDragging(true);
  };

  const handleDragEnter = (e: React.DragEvent<HTMLDivElement>) => {
    e.preventDefault();
    setIsDragging(true);
  };

  const handleDragLeave = (e: React.DragEvent<HTMLDivElement>) => {
    e.preventDefault();
    setIsDragging(false);
  };

  const handleDrop = (e: React.DragEvent<HTMLDivElement>) => {
    e.preventDefault();
    setIsDragging(false);
    const files = e.dataTransfer.files;
    if (files && files.length > 0) {
      handleFileChange({ target: { files } } as React.ChangeEvent<HTMLInputElement>);
    }
  };


  const handleMultipleResume = async () => {
    if (!selectedFiles.length) {
      toast.error("Please select at least one file to upload");
      return;
    }

    try {
      // Set loading state to true at the beginning of the operation
      setIsLoading(true);

      // Create FormData object
      const formData = new FormData();

      // Append each file to the FormData
      selectedFiles.forEach((file) => {
        formData.append('resumes', file,file.name);
      });
      // Build the URL with optional stageId as a query parameter
      let fullUrl = `${COMMON.apiBaseUrl()}/v1/${baseId}/${jobId}/application.addMultipleResumes`;

      // Add stageId as a query parameter if it exists
      if (selectedStage?.id) {
        fullUrl += `?stage_id=${encodeURIComponent(selectedStage.id)}`;
      }

      // Use your existing _baseRequest function which handles authentication
      const data = await _baseRequestFormData(
        fullUrl,
        'POST',
        formData,
        // {
        //   'Content-Type': 'multipart/form-data'
        // }
      );

      // Handle success
      toast.success(`Successfully uploaded ${selectedFiles.length} resume(s)`);

      // Close the modal
      setUploadModal(false);

      // Clear the selected files
      setSelectedFiles([]);
      setSelectedStage(null);

      // Refresh your data if needed
      // refreshJobApplications();
    } catch (error) {
      // Handle error
      console.error("Upload error:", error);
      toast.error(error.message || 'An error occurred while uploading resumes');
    } finally {
      // Set loading state back to false regardless of success or failure
      setIsLoading(false);
    }
  };



  return (

    <div className="">
      {/* <div className={`fixed top-[56px]`}
        style={{ width: verticleSidebar ? 'calc(100% - 225px)' : 'calc(100% - 59px)', zIndex: 3 }} */}
      <div className={`fixed top-[53px] rounded-tl-none rounded-tr-lg rounded-bl-none rounded-br-none bg-white`}
        style={{
          width: verticleSidebar
            ? `calc(100% - 243px${isChatOpen ? ' - 511px' : ''})`
            : `calc(100% - 68px${isChatOpen ? ' - 520px' : ''})`,
          zIndex: 3,
          borderTop: '1px solid #e0e0e0a1',
          borderBottom: '1px solid #e0e0e0a1',
          borderRight: '1px solid #e0e0e0a1',
          left: verticleSidebar ? '234px' : '59px',
          transitionProperty: 'width',
          transitionDuration: '300ms',
          transitionTimingFunction: 'ease-in-out',
        }}
      >
        <div className='flex h-full lg:h-auto shrink-0 justify-between items-center  gap-1 md:gap-2 lg:gap-4 py-2 px-2 md:py-2 lg:py-2 md:px-4 lg:px-4 flex-wrap lg:flex-nowrap'>
          <div className='flex items-center rounded-md w-full'>

            <div className="relative flex items-start text-left w-full">

              {/* <div className="flex items-center ml-[0px]">
                <button
                  className={`px-[6px] md:px-2 lg:px-2 text-[12px] md:text-[0.8125rem] lg:text-[0.8125rem] leading-[1.2] font-semibold py-[5px]
               border border-r-0 border-solid border-[rgba(0, 0, 0, 0.08)] rounded-tl-md rounded-bl-md ${activeStatus === 'Application' ? 'bg-[#6b7280] text-white  border-[#6b7280]' : 'bg-[#f9fafa] text-[#0000007a] hover:text-black-100'}`}
                  onClick={handleStatusDraft}
                >
                  Application
                </button>
                <button
                  className={`px-[6px] md:px-2 lg:px-2 text-[12px] md:text-[0.8125rem] lg:text-[0.8125rem] leading-[1.2] font-semibold py-[5px] 
                    border border-r-0 border-solid border-[rgba(0, 0, 0, 0.08)]  ${activeStatus === 'Pipeline' ? 'bg-[#6b7280] text-white border-[#6b7280]' : 'bg-[#f9fafa] text-[#0000007a] hover:text-black-100'}`}
                  onClick={handleStatusPending}
                >
                  Pipeline
                </button>
                <button
                  className={`px-[6px] md:px-2 lg:px-2 text-[12px] md:text-[0.8125rem] lg:text-[0.8125rem] leading-[1.2] font-semibold py-[5px] border
               border-solid border-[rgba(0, 0, 0, 0.08)] rounded-tr-md rounded-br-md ${activeStatus === 'Reports' ? 'bg-[#6b7280] text-white border-[#6b7280]' : 'bg-[#f9fafa] text-[#0000007a] hover:text-black-100'}`}
                  onClick={handleStatusCompleted}
                >
                  Reports
                </button>
              </div> */}
              <FilterButton label="Filter" onClick={handleMainMenuClick} />

              <div className="flex items-center justify-end w-full">

                {
                  hasActiveFilters &&
                  <div className=" px-4 w-[80%] bg-white">
                    <div className={`${!hasActiveFilters ? 'py-0' : 'py-0 flex flex-wrap w-full gap-2'}`} ref={selectedValuesRef}>


                      {Object.entries(activeFilters).map(([category, filters]) =>
                        category === 'search' ? (
                          filters && (
                            <div key="search" className="flex justify-start flex-wrap shrink-0 items-center bg-white py-0 pr-0 md:py-0 lg:py-0 md:pr-0 lg:pr-0 lg:flex-nowrap filter-btn">
                              <span className="border border-[#e5e7eb] border-solid text-[#6b7280] text-[0.75rem] gap-[0.675rem] leading-4 pr-1 pl-[0.625rem] py-1 bg-white rounded-md items-center inline-flex">
                                <span className="capitalize">Search</span>
                                <span className="bg-[#e5e7eb] w-[1px] h-[1rem] mx-1"></span>
                                <span className="text-[#111827] font-medium capitalize cursor-pointer">{filters}</span>
                                <button
                                  onClick={() => removeFilter('search', 'search')}
                                  className="text-[#6b7280] rounded justify-center items-center w-[1.25rem] h-[1.25rem] flex ml-[-.375rem] cursor-pointer"
                                >
                                  <svg viewBox="0 0 24 24" xmlns="http://www.w3.org/2000/svg" width="16" height="16" fill="currentColor" aria-hidden="true">
                                    <path d="M11.9997 10.5865L16.9495 5.63672L18.3637 7.05093L13.4139 12.0007L18.3637 16.9504L16.9495 18.3646L11.9997 13.4149L7.04996 18.3646L5.63574 16.9504L10.5855 12.0007L5.63574 7.05093L7.04996 5.63672L11.9997 10.5865Z"></path>
                                  </svg>
                                </button>
                              </span>
                            </div>
                          )
                        ) : (
                          Array.isArray(filters) && filters.length > 0 ? (
                            filters.map(({ id, value, icon, color }) => {
                              return (
                                <div key={id} className="flex justify-start flex-wrap shrink-0 items-center bg-white py-0 pr-0 md:py-0 lg:py-0 md:pr-0 lg:pr-0 lg:flex-nowrap filter-btn">
                                  <span className="border border-[#e5e7eb] border-solid text-[#6b7280] text-[0.75rem] gap-[0.675rem] leading-4 pr-1 pl-[0.625rem] py-1 bg-white rounded-md items-center inline-flex">
                                    <span className="text-[#1d2025] w-2 h-2 rounded-full bg-transparent border-2 border-solid border-[#7d7f83] block"></span>
                                    <span className="capitalize">{category}</span>
                                    <span className="bg-[#e5e7eb] w-[1px] h-[1rem] mx-1"></span>

                                    <span className="mr-[-6px]"> {renderIcon(icon)}</span>


                                    {color && (
                                      <span
                                        className="flex h-[8px] w-[8px] shrink-0 items-center justify-center rounded-full text-[0.625rem] font-medium text-white"
                                        style={{ backgroundColor: color }}
                                      ></span>
                                    )}
                                    <span
                                      className="text-[#111827] font-medium capitalize cursor-pointer"
                                      onClick={() => handleValueClick(category, id)}
                                    >
                                      {value}
                                    </span>
                                    <button
                                      onClick={() => removeFilter(category, id)}
                                      className="text-[#6b7280] rounded justify-center items-center w-[1.25rem] h-[1.25rem] flex ml-[-.375rem] cursor-pointer"
                                    >
                                      <svg viewBox="0 0 24 24" xmlns="http://www.w3.org/2000/svg" width="16" height="16" fill="currentColor" aria-hidden="true">
                                        <path d="M11.9997 10.5865L16.9495 5.63672L18.3637 7.05093L13.4139 12.0007L18.3637 16.9504L16.9495 18.3646L11.9997 13.4149L7.04996 18.3646L5.63574 16.9504L10.5855 12.0007L5.63574 7.05093L7.04996 5.63672L11.9997 10.5865Z"></path>
                                      </svg>
                                    </button>
                                  </span>
                                </div>
                              );
                            })
                          ) : null
                        )
                      )}
                    </div>

                  </div>
                }


                <div className="flex items-center justify-end w-[20%]">
                  {hasActiveFilters && (
                    <button
                      className=" items-center py-1 justify-center rounded-md font-semibold min-w-[5rem] text-[0.8125rem] px-3 hover:bg-light-gray-100"
                      onClick={handleClearAll}
                    >
                      Clear All
                    </button>
                  )}
                  {
                    !hasActiveFilters &&
                    <button
                      onClick={handleUploadModal}
                      className="group inline-flex shrink-0 select-none justify-center items-center px-[14px] py-1 text-[13px] font-medium  leading-4
                 transition-colors duration-100  focus:outline-0 focus-visible:outline focus-visible:outline-2 focus-visible:outline-offset-2 disabled:pointer-events-none
                  gap-0 rounded-md text-white bg-indigo-600 hover:bg-indigo-500 focus-visible:outline-indigo-600 h-[28px]">
                      Add candidate
                    </button>
                  }

                </div>

              </div>
              {isMainMenuOpen && (
                <div ref={mainMenuRef} className="absolute top-[27px] right-0 left-[0px] z-10 mt-2 mq575:w-[160px] mq3000:w-[234px] origin-top-right rounded-md bg-white filter-dropdown border border-solid border-[#00000014]"
                  style={{ boxShadow: '0 10px 15px -3px rgba(0, 0, 0, 0.1),0 4px 6px -2px rgba(0, 0, 0, 0.05)' }}>
                  <div className="py-1">
                    <input
                      type="search"
                      value={searchQuery}
                      onChange={(e) => setSearchQuery(e.target.value)}
                      className="w-full outline-none border-t-0 border-l-0 border-r-0 border-b border-solid border-[#00000029] 
                      rounded-none text-sm h-[36px] pl-[10px] pr-[30px focus:outline-none focus:shadow-none focus:ring-0 focus:border-[#00000029] font-normal text-[#9f9f9fff]"
                      placeholder="Filter..."
                    />
                    <span className="right-0 w-[2.25rem] h-[2.25rem] text-sm flex items-center justify-center absolute text-[#000000eb] opacity-100 bg-[#fff] top-[2px]" style={{ zIndex: 2 }}>F</span>

                    {filteredMainItems.map((item) => (
                      <button
                        key={item.id}
                        className="text-dark-black-100 flex items-center gap-[0.5rem] px-[0.75rem] py-[0.375rem] h-[32px] text-[13px] font-normal cursor-pointer w-full hover:bg-[#f1f1f2] focus:bg-[#f1f1f2] active:bg-[#e7e7e8]"
                        onClick={() => {
                          item.setMenuOpen(true);
                          setIsMainMenuOpen(false);
                        }}
                      >
                        {item.icon}
                        {item.label}
                      </button>
                    ))}
                  </div>
                </div>
              )}

              {sortMenuOpen && (
                <div ref={sortMenuRef} className="absolute top-[27px] right-0 z-10 mt-2 left-[0px] mq575:w-[160px] mq3000:w-[234px] origin-top-right rounded-md bg-white filter-dropdown border border-solid border-[#00000014]"
                  style={{ boxShadow: '0 10px 15px -3px rgba(0, 0, 0, 0.1),0 4px 6px -2px rgba(0, 0, 0, 0.05)' }}>
                  <div className="py-1">
                    <input
                      type="search"
                      value={sortSearchQuery}
                      onChange={(e) => setSortSearchQuery(e.target.value)}
                      className="w-full outline-none border-t-0 border-l-0 border-r-0 border-b border-solid border-[#00000029] 
                      rounded-none text-sm h-[36px] pl-[10px] pr-[30px focus:outline-none focus:shadow-none focus:ring-0 focus:border-[#00000029] font-normal text-dark-black-100"
                      placeholder="Sort by..."
                    />
                    <span className="right-0 w-[2.25rem] h-[2.25rem] text-sm flex items-center justify-center absolute text-[#000000eb] opacity-100 bg-[#fff] top-[2px]" style={{ zIndex: 2 }}>F</span>
                    <div className="overflow-auto max-h-[200px]">
                      {filteredSortOptions.map((item) => (
                        <button
                          key={item.id}
                          className="text-dark-black-100 flex items-center gap-[0.5rem] px-[0.75rem] py-[0.375rem] h-[32px] text-[13px] font-normal cursor-pointer w-full hover:bg-[#f1f1f2] focus:bg-[#f1f1f2] active:bg-[#e7e7e8]"
                          onClick={item.onClick}
                        >
                          {/* Show the icon */}
                          {renderIcon(item.icon)}
                          {item.label}
                        </button>
                      ))}
                    </div>
                  </div>
                </div>
              )}

              {boardsMenuOpen && (
                <div ref={boardsMenuRef} className="absolute top-[27px] right-0 z-10 mt-2 left-[0px] mq575:w-[160px] mq3000:w-[234px] origin-top-right rounded-md bg-white filter-dropdown border border-solid border-[#00000014]"
                  style={{ boxShadow: '0 10px 15px -3px rgba(0, 0, 0, 0.1),0 4px 6px -2px rgba(0, 0, 0, 0.05)' }}>
                  <div className="py-1">
                    <input
                      type="search"
                      value={boardsSearchQuery}
                      onChange={(e) => setBoardsSearchQuery(e.target.value)}
                      className="w-full outline-none border-t-0 border-l-0 border-r-0 border-b border-solid border-[#00000029] 
                      rounded-none text-sm h-[36px] pl-[10px] pr-[30px focus:outline-none focus:shadow-none focus:ring-0 focus:border-[#00000029] font-normal text-dark-black-100"
                      placeholder="Status"
                    />
                    <span className="right-0 w-[2.25rem] h-[2.25rem] text-sm flex items-center justify-center absolute text-[#000000eb]  opacity-100 bg-[#fff] top-[2px]" style={{ zIndex: 2 }}>F</span>
                    <div className=" overflow-auto max-h-[200px]">
                      {filteredBoardsItems.map((item, index) => (
                        <button
                          key={item.id}
                          // ref={el => itemsRef1.current[index] = el}
                          ref={(el) =>
                            (itemsRef1.current[index] = el)
                          }
                          className={`text-dark-black-100 flex items-center gap-[0.5rem] px-[0.75rem] py-[0.375rem] h-[32px] text-[13px] font-normal cursor-pointer w-full hover:bg-[#f1f1f2] focus:bg-[#f1f1f2] ${item.className}`}

                          // onClick={item.onClick}
                          onClick={() => {
                            if (editingFilter && editingFilter.category === 'Stages') {
                              handleFilterUpdate('Stages', editingFilter.id, item.id, item.label, item.icon);
                              clearPaginationFromState();
                            } else {
                              item.onClick();
                              clearPaginationFromState();
                            }
                          }}
                        >
                          {item.icon}
                          <span className=" whitespace-nowrap w-[150px] overflow-hidden text-ellipsis text-start">    {item.label}</span>

                        </button>
                      ))}
                    </div>
                  </div>
                </div>
              )}

              {createdMenuOpen && (
                <div ref={createdMenuRef} className="absolute top-[27px] right-0 z-10 mt-2 left-[0px] mq575:w-[160px] mq3000:w-[234px] origin-top-right rounded-md bg-white filter-dropdown border
             border-solid border-[#00000014] date-picker"
                  style={{ boxShadow: '0 10px 15px -3px rgba(0, 0, 0, 0.1),0 4px 6px -2px rgba(0, 0, 0, 0.05)' }}>

                  <Datepicker
                    value={value}
                    onChange={handleValueChange}
                    showShortcuts={true}
                  />
                </div>

              )}
              {updatedMenuOpen && (
                <div ref={updatedMenuRef} className="absolute top-[27px] right-0 z-10 mt-2 left-[0px] mq575:w-[160px] mq3000:w-[234px] origin-top-right rounded-md bg-white filter-dropdown border
                 border-solid border-[#00000014] date-picker"
                  style={{ boxShadow: '0 10px 15px -3px rgba(0, 0, 0, 0.1),0 4px 6px -2px rgba(0, 0, 0, 0.05)' }}>

                  <Datepicker
                    value={updateValue}
                    onChange={handleUpdatedValueChange}
                    showShortcuts={true}
                  />
                </div>

              )}
              {/* ai rating */}
              {
                AiRatingMenuOpen && (
                  <div ref={aiRatingMenuRef} className="absolute top-[27px] right-0 z-10 mt-2 left-[0px] mq575:w-[160px] mq3000:w-[234px] origin-top-right rounded-md bg-white filter-dropdown border border-solid border-[#00000014]"
                    style={{ boxShadow: '0 10px 15px -3px rgba(0, 0, 0, 0.1),0 4px 6px -2px rgba(0, 0, 0, 0.05)' }}>
                    <div className="py-1">
                      <input
                        type="search"
                        value={aiRatingSearchQuery}
                        onChange={(e) => setAiRatingSearchQuery(e.target.value)}
                        className="w-full outline-none border-t-0 border-l-0 border-r-0 border-b border-solid border-[#00000029] 
        rounded-none text-sm h-[36px] pl-[10px] pr-[30px focus:outline-none focus:shadow-none focus:ring-0 focus:border-[#00000029] font-normal text-dark-black-100"
                        placeholder="Sort by..."
                      />
                      <span className="right-0 w-[2.25rem] h-[2.25rem] text-sm flex items-center justify-center absolute text-[#000000eb] opacity-100 bg-[#fff] top-[2px]" style={{ zIndex: 2 }}>F</span>
                      <div className="overflow-auto max-h-[200px]">
                        {filterdAiRatingItems.map((item) => {
                          const ratingValue =
                            item.label === 'Strong Yes' ? 5 :
                              item.label === 'Yes' ? 4 :
                                item.label === 'Neutral' ? 3 :
                                  item.label === 'No' ? 2 :
                                    item.label === 'Strong No' ? 1 : 0;

                          const itemStyles = getRatingBadgeStyles(ratingValue);

                          return (
                            <button
                              key={item.id}
                              className={`flex items-center gap-[0.5rem] px-[0.75rem] py-[0.375rem] h-[32px] text-[13px] font-normal cursor-pointer w-full hover:bg-[#f1f1f2] focus:bg-[#f1f1f2] ${itemStyles.text} `}
                              onClick={item.onClick}
                            >
                              {/* Add a colored dot based on rating */}
                              <span className={`inline-block w-2 h-2 rounded-full mr-1 
                              ${ratingValue === 5 ? 'bg-green-700' :
                                  ratingValue === 4 ? 'bg-emerald-700' :
                                    ratingValue === 3 ? 'bg-blue-700' :
                                      ratingValue === 2 ? 'bg-orange-700' :
                                        ratingValue === 1 ? 'bg-red-700' : 'bg-gray-700'
                                }`}></span>
                              {renderIcon(item.icon)}
                              {item.label}
                            </button>
                          )


                        })}
                      </div>
                    </div>
                  </div>

                )
              }

              {/* user rating  */}
              {
                userRatingMenuOpen && (
                  <div ref={userRatingMenuRef} className="absolute top-[27px] right-0 z-10 mt-2 left-[0px] mq575:w-[160px] mq3000:w-[234px] origin-top-right rounded-md bg-white filter-dropdown border border-solid border-[#00000014]"
                    style={{ boxShadow: '0 10px 15px -3px rgba(0, 0, 0, 0.1),0 4px 6px -2px rgba(0, 0, 0, 0.05)' }}>
                    <div className="py-1">
                      <input
                        type="search"
                        value={userRatingSearchQuery}
                        onChange={(e) => setUserRatingSearchQuery(e.target.value)}
                        className="w-full outline-none border-t-0 border-l-0 border-r-0 border-b border-solid border-[#00000029] 
        rounded-none text-sm h-[36px] pl-[10px] pr-[30px focus:outline-none focus:shadow-none focus:ring-0 focus:border-[#00000029] font-normal text-dark-black-100"
                        placeholder="Sort by..."
                      />
                      <span className="right-0 w-[2.25rem] h-[2.25rem] text-sm flex items-center justify-center absolute text-[#000000eb] opacity-100 bg-[#fff] top-[2px]" style={{ zIndex: 2 }}>F</span>
                      <div className="overflow-auto max-h-[200px]">
                        {filteredUserRatingItems.map((item) => {
                          const itemStyles = getSkillScaleBadgeStyles(item?.label);
                          const ratingValue =
                            item.label === 'Strong Yes' ? 5 :
                              item.label === 'Yes' ? 4 :
                                item.label === 'Neutral' ? 3 :
                                  item.label === 'No' ? 2 :
                                    item.label === 'Strong No' ? 1 : 0; // Default/fallback

                          return (
                            <button
                              key={item.id}
                              className={`flex items-center gap-[0.5rem] px-[0.75rem] py-[0.375rem] h-[32px] text-[13px] font-normal cursor-pointer w-full hover:bg-[#f1f1f2] focus:bg-[#f1f1f2] ${itemStyles.text} `}
                              onClick={item.onClick}
                            >
                              {/* Add a colored dot based on rating */}
                              <span className={`inline-block w-2 h-2 rounded-full mr-1 
                              ${ratingValue === 5 ? 'bg-green-700' :
                                  ratingValue === 4 ? 'bg-blue-700' :
                                    ratingValue === 3 ? 'bg-yellow-700' :
                                      ratingValue === 2 ? 'bg-gray-700' :
                                        ratingValue === 1 ? 'bg-red-700' : 'bg-gray-700'
                                }`}></span>
                              {renderIcon(item.icon)}
                              {item?.label}
                            </button>
                          )

                        })}
                      </div>
                    </div>
                  </div>

                )
              }
            </div>
          </div>
        </div>
        {/* {
          hasActiveFilters &&
          <div className="flex items-end md:items-center lg:items-center justify-between px-4 bg-white border-b border-solid border-[#e5e7eb]">
            <div className={`${!hasActiveFilters ? 'py-0' : 'py-2 flex justify-start flex-wrap w-full gap-2'}`} ref={selectedValuesRef}>
              {Object.entries(activeFilters).map(([category, filters]) =>
                category === 'search' ? (
                  filters && (
                    <div key="search" className="flex justify-start flex-wrap shrink-0 items-center bg-white py-0 pr-0 md:py-0 lg:py-0 md:pr-0 lg:pr-0 lg:flex-nowrap filter-btn">
                      <span className="border border-[#e5e7eb] border-solid text-[#6b7280] text-[0.75rem] gap-[0.675rem] leading-4 pr-1 pl-[0.625rem] py-1 bg-white rounded-md items-center inline-flex">
                        <span className="capitalize">Search</span>
                        <span className="bg-[#e5e7eb] w-[1px] h-[1rem] mx-1"></span>
                        <span className="text-[#111827] font-medium capitalize cursor-pointer">{filters}</span>
                        <button
                          onClick={() => removeFilter('search', 'search')}
                          className="text-[#6b7280] rounded justify-center items-center w-[1.25rem] h-[1.25rem] flex ml-[-.375rem] cursor-pointer"
                        >
                          <svg viewBox="0 0 24 24" xmlns="http://www.w3.org/2000/svg" width="16" height="16" fill="currentColor" aria-hidden="true">
                            <path d="M11.9997 10.5865L16.9495 5.63672L18.3637 7.05093L13.4139 12.0007L18.3637 16.9504L16.9495 18.3646L11.9997 13.4149L7.04996 18.3646L5.63574 16.9504L10.5855 12.0007L5.63574 7.05093L7.04996 5.63672L11.9997 10.5865Z"></path>
                          </svg>
                        </button>
                      </span>
                    </div>
                  )
                ) : (
                  Array.isArray(filters) && filters.length > 0 ? (
                    filters.map(({ id, value, icon, color }) => {
                      return (
                        <div key={id} className="flex justify-start flex-wrap shrink-0 items-center bg-white py-0 pr-0 md:py-0 lg:py-0 md:pr-0 lg:pr-0 lg:flex-nowrap filter-btn">
                          <span className="border border-[#e5e7eb] border-solid text-[#6b7280] text-[0.75rem] gap-[0.675rem] leading-4 pr-1 pl-[0.625rem] py-1 bg-white rounded-md items-center inline-flex">
                            <span className="text-[#1d2025] w-2 h-2 rounded-full bg-transparent border-2 border-solid border-[#7d7f83] block"></span>
                            <span className="capitalize">{category}</span>
                            <span className="bg-[#e5e7eb] w-[1px] h-[1rem] mx-1"></span>

                            <span className="mr-[-6px]"> {renderIcon(icon)}</span>


                            {color && (
                              <span
                                className="flex h-[8px] w-[8px] shrink-0 items-center justify-center rounded-full text-[0.625rem] font-medium text-white"
                                style={{ backgroundColor: color }}
                              ></span>
                            )}
                            <span
                              className="text-[#111827] font-medium capitalize cursor-pointer"
                              onClick={() => handleValueClick(category, id)}
                            >
                              {value}
                            </span>
                            <button
                              onClick={() => removeFilter(category, id)}
                              className="text-[#6b7280] rounded justify-center items-center w-[1.25rem] h-[1.25rem] flex ml-[-.375rem] cursor-pointer"
                            >
                              <svg viewBox="0 0 24 24" xmlns="http://www.w3.org/2000/svg" width="16" height="16" fill="currentColor" aria-hidden="true">
                                <path d="M11.9997 10.5865L16.9495 5.63672L18.3637 7.05093L13.4139 12.0007L18.3637 16.9504L16.9495 18.3646L11.9997 13.4149L7.04996 18.3646L5.63574 16.9504L10.5855 12.0007L5.63574 7.05093L7.04996 5.63672L11.9997 10.5865Z"></path>
                              </svg>
                            </button>
                          </span>
                        </div>
                      );
                    })
                  ) : null
                )
              )}
            </div>
            {hasActiveFilters && (
              <button
                className="inline-flex items-center py-1 justify-center rounded-md font-semibold min-w-[5rem] text-[0.8125rem] px-3 hover:bg-light-gray-100"
                onClick={handleClearAll}
              >
                Clear All
              </button>
            )}
          </div>
        } */}




      </div>
      <div className='  z-[-9]'>
        {!showKanbanRoute && activeButton === 'one' && <BookmarkListing sectionHeight={sectionHeight} activeFilters={activeFilters}
          itemAssignedTo={assignedItemId} itemStatusDraft={assignedStatusDraftId}
          itemStatusPending={assignedStatusPendingId} itemStatusCompleted={assignedStatusCompletedId}
        />}
    
      </div>


      <Dialog open={uploadModal} onClose={() => setUploadModal(false)} className="relative z-10">
        <DialogBackdrop
          transition
          className="fixed inset-0 bg-gray-500 bg-opacity-75 transition-opacity data-[closed]:opacity-0 data-[enter]:duration-300 data-[leave]:duration-200 data-[enter]:ease-out data-[leave]:ease-in"
        />

        <div className="fixed inset-0 z-10 w-screen overflow-y-auto">
          <div className="flex min-h-full items-end justify-center p-4 text-center sm:items-center sm:p-0">
            <DialogPanel
              transition
              className="relative transform rounded-lg bg-white px-4 pb-4 pt-5 text-left shadow-xl transition-all data-[closed]:translate-y-4 data-[closed]:opacity-0 data-[enter]:duration-300 data-[leave]:duration-200 data-[enter]:ease-out data-[leave]:ease-in sm:my-8 sm:w-full sm:max-w-lg sm:p-6 data-[closed]:sm:translate-y-0 data-[closed]:sm:scale-95"
            >
              <div className="absolute right-[5px] top-[5px] hidden pr-4 pt-4 sm:block">
                <button
                  type="button"
                  onClick={() => setUploadModal(false)}
                  className="rounded-md bg-white text-gray-400 hover:text-gray-500 focus:outline-none focus:ring-2 focus:ring-indigo-500 focus:ring-offset-2"
                >
                  <span className="sr-only">Close</span>
                  <CrossIcon />
                </button>
              </div>

              <div className="flex flex-col gay-y-4">
                <DialogTitle
                  as="h3"
                  className="text-base font-semibold leading-6 text-gray-900"
                >
                  Upload Resumes 
                </DialogTitle>
                <div className="mt-5">
                  <label className="wg-label inline-flex cursor-pointer items-center gap-1 text-sm font-medium leading-6 mb-2">
                    Upload files
                  </label>
                  <div
                    className={`flex flex-col px-4 py-5 border ${isDragging ? 'border-dashed border-indigo-300 bg-indigo-50' : 'border-dashed border-gray-300'} rounded-md `}
                    onDragOver={handleDragOver}
                    onDragEnter={handleDragEnter}
                    onDragLeave={handleDragLeave}
                    onDrop={handleDrop}
                  >
                    <div className="relative flex items-center gap-2 justify-center w-full">
                      <label className="cursor-pointer justify-center flex items-center gap-2 text-gray-500">
                        Upload files (max 10)
                        <input type="file" className="hidden" onChange={handleFileChange} multiple />
                      </label>
                    </div>

                    {selectedFiles.length > 0 && (
                      <div className="mt-4 space-y-2 max-h-60 overflow-y-auto">
                        {selectedFiles.map((file, index) => (
                          <div key={index} className="flex items-center justify-between bg-gray-100 p-2 px-3 rounded-md text-gray-700">
                            <span className="text-sm truncate max-w-xs">{file.name}</span>
                            <X size={16} className="cursor-pointer text-gray-500 hover:text-red-500 flex-shrink-0" onClick={() => removeFile(index)} />
                          </div>
                        ))}
                      </div>
                    )}

                    <div className="text-xs text-gray-500 text-center mt-2">
                      {selectedFiles.length} of 10 files selected
                    </div>
                  </div>
                  <div className="flex flex-col gap-y-2 mt-5">
                    <label className="wg-label inline-flex cursor-pointer items-center gap-1 text-sm font-medium leading-6">
                      Pipeline stages
                    </label>
                    <div className=' w-full'>
                      <Listbox
                        value={selectedStage}
                        onChange={setSelectedStage}
                      >
                        <div className="relative mt-0">
                          <ListboxButton className="relative w-full bg-transparent flex items-center justify-between px-2 py-1 h-[36px] cursor-pointer  text-left text-gray-900  rounded-md border border-gray-300 outline-none">
                            <div className='flex items-center gap-x-[6px]'>
                              {selectedStage?.stage_colour && (
                                <span
                                  className='flex h-[8px] w-[8px] shrink-0 items-center justify-center rounded-[2px] border-none text-[0.625rem] font-medium text-white capitalize'
                                  style={{ background: selectedStage.stage_colour }}
                                />
                              )}
                              <span className="block truncate text-[#1b1b1b] font-normal">
                                {selectedStage?.stage_name || 'Select Stage'}
                              </span>
                            </div>
                            <span className="pointer-events-none flex items-center">
                              <svg
                                xmlns="http://www.w3.org/2000/svg"
                                width={24}
                                height={24}
                                viewBox="0 0 24 24"
                                fill="none"
                                stroke="currentColor"
                                strokeWidth={2}
                                strokeLinecap="round"
                                strokeLinejoin="round"
                                className="w-[1rem] h-[1rem] text-[#808080]"
                              >
                                <path stroke="none" d="M0 0h24v24H0z" fill="none" />
                                <path d="M6 9l6 6l6 -6" />
                              </svg>
                            </span>
                          </ListboxButton>

                          <Transition
                            as={Fragment}
                            leave="transition ease-in duration-100"
                            leaveFrom="opacity-100"
                            leaveTo="opacity-0"
                          >
                            <ListboxOptions className="absolute z-10 mt-[9px] left-[-0px] bg-white max-w-[430px] min-w-[430px] w-full overflow-hidden rounded-lg border border-border bg-popover p-1 text-popover-foreground shadow-lg shadow-black/5 data-[state=open]:animate-in data-[state=closed]:animate-out data-[state=closed]:fade-out-0 data-[state=open]:fade-in-0 data-[state=closed]:zoom-out-95 data-[state=open]:zoom-in-95 data-[side=bottom]:slide-in-from-top-2 data-[side=left]:slide-in-from-right-2 data-[side=right]:slide-in-from-left-2 data-[side=top]:slide-in-from-bottom-2 ">
                              {optionsWithAllStagesHeader.length > 0 ? (
                                optionsWithAllStagesHeader.map((option) => (
                                  <ListboxOption
                                    key={option.id}
                                    value={option}
                                    className={({ active }) =>
                                      classNames(
                                        active ? 'bg-gray-200 text-[#1d2025]' : 'text-gray-900',
                                        'relative flex select-none items-center gap-2 rounded-md px-2 py-1.5 text-sm outline-none transition-colors focus:bg-accent focus:text-accent-foreground data-[disabled]:pointer-events-none data-[disabled]:opacity-50 [&_svg]:pointer-events-none [&_svg]:shrink-0 cursor-pointer'
                                      )
                                    }
                                  >
                                    {({ selected, active }) => (
                                      <>
                                        <div className='flex items-center justify-between w-full'>
                                          <div className='flex items-center gap-x-[6px]'>
                                            <span
                                              className='flex h-[8px] w-[8px] shrink-0 items-center justify-center rounded-[2px] border-none text-[0.625rem] font-medium text-white capitalize'
                                              style={{ background: option?.stage_colour }}
                                            />
                                            <span className={classNames(selected ? 'font-semibold' : 'font-normal', 'block truncate')}>
                                              {option.stage_name}
                                            </span>
                                          </div>

                                        </div>
                                      </>
                                    )}
                                  </ListboxOption>
                                ))
                              ) : (
                                <div className="px-4 py-2 text-sm text-gray-500">No pipeline stages available</div>
                              )}
                            </ListboxOptions>
                          </Transition>
                        </div>
                      </Listbox>
                    </div>
                  </div>



                  <div className="flex items-center justify-end mt-5">

                    <button
                      type="button"
                      onClick={handleMultipleResume}
                      className=" inline-flex shrink-0  justify-center rounded-md bg-indigo-600 px-[14px] py-1 text-sm font-medium leading-6 text-white shadow-sm hover:bg-indigo-500
                                         focus-visible:outline focus-visible:outline-2 focus-visible:outline-offset-2 focus-visible:outline-indigo-600"
                    >
                      <div className='flex items-center  gap-[6px]'>
                        Create
                        {isLoading && (
                          <div className="simple-spinner">
                            <span></span>
                          </div>
                        )}
                      </div>
                    </button>


                  </div>
                </div>
              </div>
            </DialogPanel>
          </div>
        </div>
      </Dialog>






    </div>

  )
}
